import React from 'react';
import PropTypes from 'prop-types';
import {Button as AntButton} from 'antd';
import {BlocksControls, InlineTextarea} from 'react-tinacms-inline';
import {box} from '../../constants/fields/fields';
import {ImageStyled} from '../Common/ImageStyled';
import {useBlockProps} from '../../hooks/useBlockProps';
import {Content} from '../Common/Content';
import {usePage} from '../../contexts/PageContext';
import {buttonTemplate} from '../../constants/templates/button';
import {buttonSimpleField} from '../../constants/fields/button.fields';
import {Link} from 'react-router-dom';
import {useCMS} from 'tinacms';


const LogicLink = ({to, children, disabled}) => {
  if (!to || disabled) return children;

  if (to.startsWith('http'))
    return (<a href={to} target="_blank" rel="noreferrer">
      {children}
    </a>);
  return (
    <Link to={to}>
      {children}
    </Link>
  );
};


function ButtonComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  const {_enabled} = useCMS();
  const button = blockProps.button || {};
  const danger = button.type === 'danger';
  const redirect = button.redirect;
  const type = danger ? 'primary' : button.type;
  const shape = button.shape ? 'round' : undefined;

  const {language} = usePage();
  return (
    <div>
      <BlocksControls index={index} focusRing={{offset: 0}}>
        <Content {...blockProps} title={undefined} className={'dlf-no-margin-horizontal'}>
          <ImageStyled viewport={blockProps.viewport}>
            <LogicLink to={redirect} disabled={_enabled} >
              <AntButton {...button} danger={danger} type={type} shape={shape} className={'w-full'}>
                <InlineTextarea name={`title.${language}`} focusRing={false}/>
              </AntButton>
            </LogicLink>
          </ImageStyled>
        </Content>
      </BlocksControls>
    </div>
  );
}

const template = {
  label: 'Button',
  defaultItem: buttonTemplate,
  fields: [
    ...buttonSimpleField,
    // shadow,
    box
  ]
};

export const Button = {
  Component: ButtonComponent,
  template
};
export const ButtonForColumn = {
  Component: ButtonComponent,
  template: {
    ...template,
    fields: [
      ...buttonSimpleField,
      // shadow,

    ]
  }
};

ButtonComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};

LogicLink.propTypes = {
  children: PropTypes.any,
  disabled: PropTypes.bool,
  to: PropTypes.string
};
